import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Row,
  Typography,
} from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  addRoles,
  getRolesPermissions,
  getSingleRoles,
} from "../../../../actions/companySettings";
import { objectToFormData } from "../../../../utils";
import "./../userControl.css";
import { useFormik } from "formik";
const _ = require("lodash");
const { Text } = Typography;

const ValidationSchema = yup.object().shape({
  role_name: yup.string().required("Please Enter role name"),
});

const AddRoles = (props) => {
  const { id: currentId = "" } = props;

  const dispatch = useDispatch();
  const [permissionsDataCheck, setPermissionsDataCheck] = React.useState({});
  const [selectAll, setSelectAll] = React.useState({
    read: false,
    write: false,
  });
  const singleRolesResponse = useSelector(
    (state) => state.companySetting.getSingleRoles || {}
  );

  const addRolesResponse = useSelector(
    (state) => state.companySetting.addRoles || {}
  );

  const handleSubmit = (values) => {
    const permissionsArray = [];
    const payload = {};
    Object.entries(values).forEach(([key, value]) => {
      if (value) {
        permissionsArray.push(
          key.startsWith("permissionsForm_") &&
            key.replace("permissionsForm_", "")
        );
      }
    });

    if ([...permissionsArray].filter((ele) => ele !== false).length === 0) {
      message.error(
        <span className="messageText">Permissions are required</span>
      );
      return;
    }

    Object.keys(payload).forEach((key) => {
      if (!payload[key]) {
        delete payload[key];
      }
    });
    payload.role_name = values.role_name;
    payload.description = values.description ? values.description : "";
    if (values.is_corporate_checker !== undefined)
      payload.is_corporate_checker = values.is_corporate_checker;
    currentId
      ? dispatch(
          addRoles(
            objectToFormData({
              ...payload,
              id: currentId.toString(),
              permissions: _.uniq([...permissionsArray]).filter(Boolean),
            })
          )
        )
      : dispatch(
          addRoles(
            objectToFormData({
              ...payload,
              permissions: _.uniq([...permissionsArray]).filter(Boolean),
            })
          )
        );
    formik.resetForm();
    setPermissionsDataCheck({});
  };

  const formik = useFormik({
    initialValues: {
      role_name: "",
      description: "",
      is_corporate_checker: false,
    },
    validationSchema: ValidationSchema,
    // enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values),
  });

  React.useEffect(() => {
    const { data: { status = "" } = {} } = addRolesResponse;
    if (status || status === false) {
      setSelectAll({
        read: false,
        write: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addRolesResponse]);

  React.useEffect(() => {
    if (currentId) {
      dispatch(getSingleRoles({ id: currentId }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentId]);

  React.useEffect(() => {
    setPermissionsDataCheck(props.permissionsData);
  }, [props.permissionsData]);

  // React.useEffect(() => {
  //   if (singleRolesResponse.success && currentId) {
  //     const { data: { response: { permissions = {} } = {} } = {} } =
  //       singleRolesResponse;
  //     let obj = {};
  //     let initArr = [];
  //     Object.keys(permissions).forEach((ele) => {
  //       obj[ele] = {
  //         read: permissions[ele]?.find((ele) => ele.action === "read")
  //           ? true
  //           : false,
  //         write: permissions[ele]?.find((ele) => ele.action === "write")
  //           ? true
  //           : false,
  //       };
  //     });
  //     Object.keys(obj).forEach((ele) => {
  //       if (obj[ele].read) {
  //         initArr.push("permissionsForm_Read_" + ele);
  //         formik.setFieldValue("permissionsForm_Read_" + ele, true);
  //       }
  //       if (obj[ele].write) {
  //         initArr.push("permissionsForm_Write_" + ele);
  //         formik.setFieldValue("permissionsForm_Write_" + ele, true);
  //       }
  //     });

  //     setPermissionsDataCheck({
  //       ...props.permissionsData,
  //       ...obj,
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [singleRolesResponse]);

  React.useEffect(() => {
    if (singleRolesResponse.success && currentId) {
      const { data: { response: { permissions = {} } = {} } = {} } =
        singleRolesResponse;

      let obj = {};
      Object.keys(permissions).forEach((ele) => {
        obj[ele] = {
          read: permissions[ele]?.find((x) => x.action === "read")
            ? true
            : false,
          write: permissions[ele]?.find((x) => x.action === "write")
            ? true
            : false,
        };
      });

      // merge defaults with actual
      let merged = { ...props.permissionsData };
      Object.keys(obj).forEach((key) => {
        merged[key] = obj[key];
      });

      // init form fields (explicit true/false)
      Object.keys(merged).forEach((ele) => {
        formik.setFieldValue(`permissionsForm_Read_${ele}`, merged[ele].read);
        formik.setFieldValue(`permissionsForm_Write_${ele}`, merged[ele].write);
      });

      setPermissionsDataCheck(merged);
    }
  }, [singleRolesResponse]);

  React.useEffect(() => {
    if (formik.values.role_name === "") {
      formik.setFieldValue("role_name", props?.selectedRecord?.role_name);
      formik.setFieldValue("description", props?.selectedRecord?.description);
      formik.setFieldValue(
        "is_corporate_checker",
        props?.selectedRecord?.is_corporate_checker
          ? props?.selectedRecord?.is_corporate_checker
          : false
      );
    }
  }, [singleRolesResponse]);

  const handleCancelButton = () => {
    setPermissionsDataCheck({});
    props.handleCancel();
  };

  // const checkForAdmin = () => {
  //   let testCheck = false;
  //   Object.entries(permissionsDataCheck).forEach(([key]) => {
  //     if (
  //       !(permissionsDataCheck[key].read && permissionsDataCheck[key].write)
  //     ) {
  //       testCheck = true;
  //       return;
  //     }
  //   });
  //   return testCheck;
  // };

  const checkForAdmin = () => {
    if (!permissionsDataCheck || Object.keys(permissionsDataCheck).length === 0)
      return true;

    let hasNonAdminPermission = false;

    Object.entries(permissionsDataCheck).forEach(([key, value]) => {
      if (!(value.read && value.write)) {
        hasNonAdminPermission = true;
      }
    });

    return hasNonAdminPermission;
  };

  return (
    <>
      <Form
        layout="vertical"
        className="modal-form"
        onFinish={formik.handleSubmit}
      >
          <Form.Item
              label="Role Name"
              required
              validateStatus={
                formik.errors.role_name &&
                (formik.touched.role_name || formik.submitCount > 0)
                  ? "error"
                  : ""
              }
              help={
                (formik.touched.role_name || formik.submitCount > 0) &&
                formik.errors.role_name
              }
            >
              <Input
                placeholder="Role name"
                maxLength={50}
                value={formik.values.role_name}
                disabled={["Admin", "Employee", "Approver"].includes(
                  formik.values.role_name
                )}
                name="role_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur} 
              />
           </Form.Item>
        <Form.Item label="Role Description">
          <Input
            placeholder="Role description (Optional)"
            value={formik.values.description}
            name="description"
            onChange={formik.handleChange}
          />
        </Form.Item>
        <Form.Item label="Is Corporate Checker" className="checker_checkbox">
          <Checkbox
            name="is_corporate_checker"
            checked={formik.values.is_corporate_checker}
            onChange={(e) => {
              formik.setFieldValue("is_corporate_checker", e.target.checked);
              dispatch(
                getRolesPermissions({
                  cc: e.target.checked,
                })
              );
            }}
          />
        </Form.Item>
        <div className="dividerText">Define permissions for this role</div>

        <Row className="mt2">
          <div className="premission-head">
            <h3 className="mb2">Permissions</h3>
            <div>
              {/* <div className="floatRightDiv">
                <Form.Item valuePropName="checked">
                  <p className="smallP">
                    <Text>Select All Write</Text>
                    <Checkbox
                      checked={selectAll.write}
                      onChange={(e) => {
                        let arr = { ...permissionsDataCheck };
                        Object.entries(permissionsDataCheck).forEach(
                          ([key]) => {
                            arr[key].write = e.target.checked;
                            arr[key].read = e.target.checked;
                            formik.setFieldValue(
                              `permissionsForm_Write_${key}`,
                              e.target.checked
                            );
                            formik.setFieldValue(
                              `permissionsForm_Read_${key}`,
                              e.target.checked
                            );
                          }
                        );
                        setPermissionsDataCheck(arr);
                        setSelectAll((obj) => ({
                          ...obj,
                          write: e.target.checked,
                          read: e.target.checked,
                        }));
                      }}
                    />
                  </p>
                </Form.Item>
              </div>
              <div className="floatRightDiv">
                <Form.Item valuePropName="checked">
                  <p className="smallP">
                    <Text>Select All Read</Text>
                    <Checkbox
                      checked={selectAll.read}
                      disabled={selectAll.write}
                      onChange={(e) => {
                        let arr = { ...permissionsDataCheck };
                        Object.entries(permissionsDataCheck).forEach(
                          ([key]) => {
                            arr[key].read = e.target.checked;
                            formik.setFieldValue(
                              `permissionsForm_Read_${key}`,
                              e.target.checked
                            );
                          }
                        );
                        setPermissionsDataCheck(arr);
                        setSelectAll((obj) => ({
                          ...obj,
                          read: e.target.checked,
                        }));
                      }}
                    />
                  </p>
                </Form.Item>
              </div> */}
            </div>
          </div>
          {permissionsDataCheck &&
            Object.entries(permissionsDataCheck).map(([key]) => (
              <Col span={24} key={key}>
                <Text>
                  {_.startCase(key)}
                  <div className="floatRightDiv">
                    <Form.Item
                      name={`permissionsForm_Write_${key}`}
                      valuePropName="checked"
                    >
                      <p className="smallP">
                        Write
                        <Checkbox
                          checked={permissionsDataCheck[key].write}
                          onChange={(e) => {
                            let arr = { ...permissionsDataCheck };
                            arr[key].write = e.target.checked;
                            arr[key].read = e.target.checked;
                            formik.setFieldValue(
                              `permissionsForm_Read_${key}`,
                              e.target.checked
                            );
                            formik.setFieldValue(
                              `permissionsForm_Write_${key}`,
                              e.target.checked
                            );

                            setPermissionsDataCheck(arr);
                          }}
                        />
                      </p>
                    </Form.Item>
                  </div>
                  <div className="floatRightDiv">
                    <Form.Item
                      name={`permissionsForm_Read_${key}`}
                      valuePropName="checked"
                    >
                      <p className="smallP">
                        Read
                        <Checkbox
                          checked={permissionsDataCheck[key].read}
                          disabled={permissionsDataCheck[key].write}
                          onChange={(e) => {
                            let arr = { ...permissionsDataCheck };
                            arr[key].read = e.target.checked;
                            formik.setFieldValue(
                              `permissionsForm_Read_${key}`,
                              e.target.checked
                            );
                            setPermissionsDataCheck(arr);
                          }}
                        />
                      </p>
                    </Form.Item>
                  </div>
                </Text>
              </Col>
            ))}
          {!checkForAdmin() && !formik.values.is_corporate_checker && (
            <div
              style={{
                color: "red",
              }}
            >
              You cannot give all permissions same as Admin.
            </div>
          )}
        </Row>

        <Button
          key="1"
          htmlType="submit"
          className="formButton mt1 primaryButton"
          disabled={!checkForAdmin() && !formik.values.is_corporate_checker}
        >
          {currentId ? "Update" : "Submit"}
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancelButton()}
        >
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default AddRoles;
